const Table = () => import('@/../../coreui/components/ServerTable')
export default function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Metrc'))  {
    return [
      
      {
        path: '/MetrcLicense',
        name: 'MetcLicense',
        component: Table, 
        props: {
          schema: 'sch_metrc_lic', 
          table: 'metrc_lic', 
          editable: false,
          top: {title: true}
        }  
      },
      {
        path: '/MetrcItemBrand',
        name: 'MetrcItemBrand',
        component: Table, 
        props: {
          schema: 'sch_metrc_itembrand', 
          table: 'metrc_itembrand', 
          editable: false, 
          top: {title: true}
        }  
      },
      {
        path: '/MetrcLabStates',
        name: 'MetrcLabStates',
        component: Table, 
        props: {
          schema: 'sch_metrc_labstates', 
          table: 'metrc_labstates', 
          editable: false,
          top: {title: true}
        }  
      },
      {
        path: '/MetrcLabTypes',
        name: 'MetrcLabTypes',
        component: Table, 
        props: {
          schema: 'sch_metrc_labtypes', 
          table: 'metrc_labtypes', 
          editable: false,
          top: {title: true}
        }  
      },
      {
        path: '/MetrcPackageTypes',
        name: 'MetrcPackageTypes',
        component: Table, 
        props: {
          schema: 'sch_metrc_packagetypes', 
          table: 'metrc_packagetypes', 
          editable: false,
          top: {title: true}
        }  
      },
      {
        path: '/MetrcPackageAdjust',
        name: 'MetrcPackageAdjust',
        component: Table, 
        props: {
          schema: 'sch_metrc_packageadjust', 
          table: 'metrc_packageadjust', 
          editable: false,
          top: {title: true}
        }  
      },
      {
        path: '/MetrcPlantBatchTypes',
        name: 'MetrcPlantBatchTypes',
        component: Table, 
        props: {
          schema: 'sch_metrc_batchtypes', 
          table: 'metrc_batchtypes', 
          editable: false,
          top: {title: true}
        }  
      },
      {
        path: '/MetrcPlantGrowth',
        name: 'MetrcPlantGrowth',
        component: Table, 
        props: {
          schema: 'sch_metrc_plantgrowth', 
          table: 'metrc_plantgrowth', 
          editable: false,
          top: {title: true}
        }  
      },
      {
        path: '/MetrcAddTypes',
        name: 'MetrcAddTypes',
        component: Table, 
        props: {
          schema: 'sch_metrc_addtypes', 
          table: 'metrc_addtypes', 
          editable: false,
          top: {title: true}
        }  
      },
      {
        path: '/MetrcWasteMethods',
        name: 'MetrcWasteMethods',
        component: Table, 
        props: {
          schema: 'sch_metrc_wmethods', 
          table: 'metrc_wmethods', 
          editable: false,
          top: {title: true}
        }  
      },
      {
        path: '/MetrcWasteReasons',
        name: 'MetrcWasteReasons',
        component: Table, 
        props: {
          schema: 'sch_metrc_wreasons', 
          table: 'metrc_wreasons', 
          editable: false,
          top: {title: true}
        }  
      },
      {
        path: '/MetrcCustomerTypes',
        name: 'MetrcCustomerTypes',
        component: Table, 
        props: {
          schema: 'sch_metrc_ctypes', 
          table: 'metrc_ctypes', 
          editable: false,
          top: {title: true}
        }  
      },
      {
        path: '/MetrcXferStates',
        name: 'MetrcXferStates',
        component: Table, 
        props: {
          schema: 'sch_metrc_xferstates', 
          table: 'metrc_xferstates', 
          editable: false,
          top: {title: true}
        }  
      },
      {
        path: '/MetrcUnits',
        name: 'MetrcUnits',
        component: Table, 
        props: {
          schema: 'sch_metrc_units', 
          table: 'metrc_units', 
          editable: false,
          top: {title: true}
        }  
      },
      // {
      //   path: '/Uploads',
      //   name: 'Uploads',
      //   component: Table, 
      //   props: {schema: 'sch_fac_products', table: 'fac_products'}  
      // }, 
      // {
      //   path: '/MetrcHistory',
      //   name: 'History',
      //   component: Table, 
      //   props: {schema: 'sch_fac_products', table: 'fac_products'}  
      // }, 
      {
        path: '/MetrcLabTests',
        name: 'LabTests',
        component: Table, 
        props: {
          schema: 'sch_metrc_labtests', 
          table: 'metrc_labtests', 
          editable: false,
          top: {title: true}
        }  
      }, 
      {
        path: '/MetrcEmployees',
        name: 'MetrcEmployees',
        component: Table, 
        props: {
          schema: 'sch_metrc_employees', 
          table: 'metrc_employees',
          editable: false,
          top: {title: true}
        }  
      }, 
      {
        path: '/MetrcFacilities',
        name: 'Facilities',
        component: Table, 
        props: {
          schema: 'sch_metrc_facilities', 
          table: 'metrc_facilities', 
          editable: false,
          top: {title: true}
        }  
      }, 
      {
        path: '/MetrcHarvests',
        name: 'Harvests',
        component: Table, 
        props: {
          schema: 'sch_metrc_harvests', 
          table: 'metrc_harvests', 
          editable: false,
          top: {title: true}
        }  
      }, 
      {
        path: '/MetrcItems',
        name: 'Items',
        component: Table, 
        props: {
          schema: 'sch_metrc_items', 
          table: 'metrc_items', 
          editable: true,
          top: {title: true}
        }  
      }, 
      {
        path: '/MetrcPackages',
        name: 'Packages',
        component: Table, 
        props: {
          schema: 'sch_metrc_package', 
          table: 'metrc_package', 
          editable: true,
          top: {title: true}
        }  
      }, {
        path: '/MetrcPatients',
        name: 'Patients',
        component: Table, 
        props: {
          schema: 'sch_metrc_patients', 
          table: 'metrc_patients', 
          editable: false,
          top: {title: true}
        }  
      }, 
      {
        path: '/MetrcPlantBatches',
        name: 'PlantBatches',
        component: Table, 
        props: {
          schema: 'sch_metrc_plantbatches', 
          table: 'metrc_plantbatches', 
          editable: false,
          top: {title: true}
        }  
      }, 
      {
        path: '/MetrcPlants',
        name: 'Plants',
        component: Table, 
        props: {
          schema: 'sch_metrc_plants', 
          table: 'metrc_plants', 
          editable: false,
          top: {title: true}
        }  
      }, 
      {
        path: '/MetrcRooms',
        name: 'Rooms',
        component: Table, 
        props: {
          schema: 'sch_metrc_rooms', 
          table: 'metrc_rooms', 
          editable: false,
          top: {title: true}
        }  
      }, 
      {
        path: '/MetrcSTrains',
        name: 'Strains',
        component: Table, 
        props: {
          schema: 'sch_metrc_strains', 
          table: 'metrc_strains', 
          editable: false,
          top: {title: true}
        }  
      }, 
      {
        path: '/MetrcHarvestWasteType',
        name: 'MetrcHarvestWasteType',
        component: Table, 
        props: {
          schema: 'sch_metrc_harvestwtype', 
          table: 'metrc_harvestwtype', 
          editable: false,
          top: {title: true}
        }  
      }, 
      {
        path: '/MetrcItemCategory',
        name: 'MetrcItemCategory',
        component: Table, 
        props: {
          schema: 'sch_metrc_itemcategory', 
          table: 'metrc_itemcategory', 
          editable: false,
          top: {title: true}
        }  
      }, 
      {
        path: '/MetrcTransfers',
        name: 'MetrcTransfers',
        component: Table, 
        props: {
          schema: 'sch_metrc_transfers', 
          table: 'metrc_transfers', 
          editable: false,
          top: {title: true}}  
      },
      {
        path: '/MetrcLocationTypes',
        name: 'MetrcLocationTypes',
        component: Table,
        props: {
          schema: 'sch_metrc_locationtypes',
          table: 'metrc_locationtypes',
          editable: false,
          top: {title: true}
        }
      },
      {
        path: '/MetrcWMix',
        name: 'MetrcWMix',
        component: Table,
        props: {
          schema: 'sch_metrc_wmix',
          table: 'metrc_wmix',
          editable: true,
          top: {title: true}
        }
      }
  ] } else return []
}
